import * as React from 'react';

import { Participant as ParticipantParams } from 'types';
import { Profile } from 'components';
import { getName } from 'utils';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';

type ParticipantProps = ParticipantParams;

const Participant: React.FC<ParticipantProps> = ({ ...participant }) => {
  const { dataStore } = useStores();

  const handleClick = () => {
    dataStore.setSelectedParticipant(participant);
  };

  return (
    <Profile
      hasAmount
      onClick={handleClick}
      selected={participant.participantId === dataStore.selectedParticipant?.participantId}
      size="large"
      amount={participant.amount}
      img={participant.personage.imageLink}
      name={getName(participant.personage.firstName, participant.personage.lastName)}
      hasParticipant={dataStore.hasParticipants}
    />
  );
};

export default observer(Participant);
